import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const DestroyAdditionalPayment = gql`
  mutation DestroyAdditionalPayment($additionalTerminationPaymentId: ID!) {
    destroyAdditionalPayment(
      input: { additionalTerminationPaymentId: $additionalTerminationPaymentId }
    ) {
      errors
    }
  }
`

export const useDestroyAdditionalPayment = (options?: MutationHookOptions) => {
  return useMutation(DestroyAdditionalPayment, options)
}
